"use client";

import { useQuery } from "@tanstack/react-query";
import type { AxiosInstance } from "axios";
import { useAxios } from "@/app/providers/AxiosProvider";
import { useSignalsAccess } from "./useSignals";
import type { CandidateProfile } from "./types";

/** Everything DOTS knows about a candidate (null when DOTS returned nothing usable). */
export function useCandidateProfile(candidateId: string) {
  const api = useAxios() as AxiosInstance;
  const access = useSignalsAccess();
  return useQuery({
    queryKey: ["dots-profile", access.scope, candidateId],
    queryFn: async ({ signal }) => (await api.get<{ data: CandidateProfile | null }>(`/signals/research/${candidateId}/profile`, { signal })).data.data,
    enabled: access.enabled && /^\d+$/.test(candidateId), staleTime: 5 * 60_000, retry: false,
  });
}
